import { useState, useRef } from 'react'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import * as ContactoService from '../servicios/contactoService'
import './contacto.css'
import 'bootstrap/dist/css/bootstrap.min.css'

const Contacto = () => {
  const { loginDataContext: { empid } = {} } = useAuth()
  const [msgForm, setMsgForm] = useState({
    usuario: localStorage.getItem('usuario'),
    empid,
    nombre: '',
    email: '',
    mensaje: ''
  })
  const [sucess, setSucess] = useState(false)

  const form = useRef()

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()
      await ContactoService.enviarMensaje(msgForm)
      form.current.reset()
      setSucess(true)
    } catch (error) {
      const mensaje = `Ocurrió un error al enviar el mensaje.`
      toastErrorLog(error, mensaje, 'contacto')
    }
  }

  const handleChange = (e) => {
    setMsgForm({ ...msgForm, [e.target.name]: e.target.value })
  }
  return (
    <div className="col-12 col-lg-6 mt-3">
      <form onSubmit={handleSubmit} ref={form}>
        <label>
          <i>Nombre</i>
        </label>
        <input
          name="nombre"
          className="input-text w-100"
          type="text"
          required
          onChange={handleChange}
        />
        <br />
        <br />
        <label>
          <i>E-mail</i>
        </label>
        <input
          name="email"
          className="input-text w-100"
          type="email"
          required
          onChange={handleChange}
        />
        <br />
        <br />
        <label>
          <i>¿En qué podemos ayudarlo?</i>
        </label>
        <textarea
          name="mensaje"
          className="text-area mt-3"
          required
          onChange={handleChange}
        ></textarea>
        <br />
        <div>
          <button type="submit" className="btn btn-success mb-2">
            Enviar Comentarios
          </button>
        </div>
      </form>
      {sucess && (
        <div>
          <br />
          <b>Sus comentarios han sido enviados, Muchas gracias.</b>
        </div>
      )}
    </div>
  )
}
export default Contacto
